import type { HomeTechnicalFeatureData } from "@/lib/homepage";

type TechnicalFeatureProps = {
  data?: HomeTechnicalFeatureData;
};

const DEFAULT_DATA: Required<HomeTechnicalFeatureData> = {
  heading: "Problem / Solution Statement",
  description:
    "Gain real-time insights into your cash flow and financial positions with OnPlexus. Our platform provides unparalleled visibility and control over your global financial operations.",
  ctaLabel: "Let's get started",
  ctaUrl: "#",
  imageSrc: "https://api.builder.io/api/v1/image/assets/TEMP/32e627dc53287162b5430c9db9bf6d38241396e0",
  imageAlt: "Feature illustration",
};

export default function TechnicalFeature({ data }: TechnicalFeatureProps) {
  const resolved: Required<HomeTechnicalFeatureData> = {
    heading: data?.heading || DEFAULT_DATA.heading,
    description: data?.description || DEFAULT_DATA.description,
    ctaLabel: data?.ctaLabel || DEFAULT_DATA.ctaLabel,
    ctaUrl: data?.ctaUrl || DEFAULT_DATA.ctaUrl,
    imageSrc: data?.imageSrc || DEFAULT_DATA.imageSrc,
    imageAlt: data?.imageAlt || DEFAULT_DATA.imageAlt,
  };

  return (
    <section className="py-[100px] bg-onplexus-dark">
      <div className="w-full max-w-[1140px] mx-auto">
        {/* D-Divider */}
        <div className="flex max-w-6xl mx-auto px-4">
          <div className="flex flex-col w-full gap-5 relative ">
            <div className="tech-div-hoz tech-div-fl tech-div-fr  md:hidden"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr hidden md:flex"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr md:hidden"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr hidden md:flex"></div>
          </div>
        </div>
          {/* Row - 1 */}
        <div className="flex max-w-6xl mx-auto px-4">
          <div className="tech-div-ver tech-div-ft tech-div-fb md:hidden"></div>
          <div className="flex gap-0 w-full relative items-stretch tech-benefit-container">
            <div className="tech-div-ver tech-div-ft tech-div-fb hidden md:flex"></div>
            {/* IMAGE Side - Feature Showcase */}
            <div className="flex flex-col tech-detail-row-img-container">
                <div className="flex flex-col h-full items-center justify-center tech-detail-row-img ">
                  <img
                    src={resolved.imageSrc}
                    alt={resolved.imageAlt}
                    className="w-full h-auto object-cover"
                  />
                </div>
            </div>
            <div className="tech-div-ver tech-div-ft tech-div-fb hidden md:flex"></div>
            {/* DETAILS Side - Growth Content */}
            <div className="flex flex-col justify-center tech-detail-row-details-container">
              <div className="flex flex-col gap-5 ">
                <div className="tech-div-hoz tech-div-fl md:hidden"></div>
              </div>
              {/* Details */}
                <div className="flex flex-col gap-6 justify-center px-6 py-9 sm:px-12 sm:py-12 md:px-12 md:py-12 lg:px-12 lg:py-12">
                  <div className="flex w-full flex-col gap-2 items-center">
                    <h2 className="w-full text-white font-bold text-xl leading-6">
                      {resolved.heading}
                    </h2>
                    <p className="self-stretch text-white/70 text-[15px] font-normal leading-normal">
                      {resolved.description}
                    </p>
                  </div>
                    <a
                      href={resolved.ctaUrl}
                      className="flex w-fit h-[45px] pl-5 pr-3 justify-center items-center gap-1.5 rounded-xl border border-onplexus-gold text-onplexus-gold hover:bg-onplexus-gold hover:text-onplexus-dark transition-colors font-semibold text-lg"
                    >
                      <span className="font-semibold text-lg">{resolved.ctaLabel}</span>
                      <span className="onplexus-icon text-5xl pt-0.5">→</span>
                    </a>
                </div>
            </div>
          </div>
        </div>
        {/* D-Divider */}
        <div className="flex max-w-6xl mx-auto px-4">
          <div className="flex flex-col w-full gap-5 relative ">
            <div className="tech-div-hoz tech-div-fl tech-div-fr md:hidden"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr hidden md:flex"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr md:hidden"></div>
            <div className="tech-div-hoz tech-div-fl tech-div-fr hidden md:flex"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
